import React from 'react';
import classNames from 'classnames';
import { getIsMobile } from '../../common/store/base-params/base-params-selectors';
import { useApi } from '../api-provider';
import { LockedCommentsIcon } from '../components/icons/locked-comments-icon';
import { useTranslate } from '../context/api-context/translations/use-translate';
import { COMMENTING_LOCKED } from '../../common/constants/data-hooks';
import styles from './commenting-locked-empty-state.module.scss';
const CommentingLockedEmptyState = () => {
    const isMobile = useApi(getIsMobile);
    const t = useTranslate();
    return (React.createElement("div", { className: classNames(styles.root, isMobile && styles.isMobile), "data-hook": COMMENTING_LOCKED },
        React.createElement(LockedCommentsIcon, { className: styles.icon }),
        React.createElement("span", { className: styles.text }, t('empty-state.commenting-locked-text'))));
};
export default CommentingLockedEmptyState;
//# sourceMappingURL=commenting-locked-empty-state.js.map